import { Card as MuiCard, CardProps as MuiCardProps, SxProps, Theme, Typography, useMediaQuery } from "@mui/material";
import { ReactNode, forwardRef } from "react";
import { Box, Stack } from "../../components";
import { useTheme } from "../../hooks";

type CardProps = MuiCardProps & {
  header?: ReactNode;
  fullHeight?: boolean;
  headerSx?: SxProps<Theme>;
  bodySx?: SxProps<Theme>;
  transparentHeader?: boolean;
};

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ sx, transparentHeader, header, fullHeight, onClick, headerSx, children, ...rest }, ref) => {
    const theme = useTheme();
    const upSm = useMediaQuery(theme.breakpoints.up("sm"));

    const renderBodyContent = () => {
      return (
        <Box
          p={4}
          borderRadius={10}
          flexGrow={1}
          overflow="auto"
          sx={{
            "&:hover": {
              backgroundColor: onClick ? theme.palette.action.hover : undefined,
              cursor: onClick ? "pointer" : "unset",
            },
            ...rest.bodySx,
          }}
        >
          {children}
        </Box>
      );
    };

    return (
      <MuiCard
        ref={ref}
        sx={{
          ...sx,
          display: "flex",
          flexDirection: "column",
          // overflow: fullHeight ? "auto" : "unset",
          height: fullHeight ? "100%" : "auto",
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
          borderRadius: 3,
          transition: 'all 0.3s ease',
        }}
        onClick={onClick}
        {...rest}
      >
        {header && (
          <Box
            display="grid"
            alignItems={"center"}
            sx={{ ...headerSx }}
            borderBottom={1}
            borderColor={theme.palette.border.main}
            backgroundColor={transparentHeader ? null : "#08519c"}
            color={transparentHeader ? theme.palette.primary.main : theme.palette.info.main }
            p={"4"}
            px={3.5}
            minHeight={50}
            fontSize={"1.15rem"}
          >
            {header}
          </Box>
        )}

        {renderBodyContent()}
      </MuiCard>
    );
  }
);
